module.exports = __webpack_public_path__ + "static/media/Night1.3569c1ac.jpg";